import { LocaleInput } from "@fullcalendar/common";
import { AvailableLocaleCodes } from "../../../stores/localizationStore";

export type LocaleImport = Promise<{ default: LocaleInput }>;

const locales: Partial<Record<AvailableLocaleCodes, LocaleImport>> = {
    en_GB: import("@fullcalendar/core/locales/en-gb"),

    es: import("@fullcalendar/core/locales/es"),
    es_ES: import("@fullcalendar/core/locales/es"),
    es_MX: import("@fullcalendar/core/locales/es"),

    fr: import("@fullcalendar/core/locales/fr"),
    de: import("@fullcalendar/core/locales/de"),
};

export const getFCLocale = async (locale: keyof typeof locales): Promise<LocaleInput | undefined> => {
    const data = await locales[locale];

    return data?.default ?? undefined;
};
